interface SchemeAndBuildingInlineSVGProps {
  color: string;
  style: React.CSSProperties;
}

const SchemeAndBuildingInlineSVG = ({
  color,
  style,
}: SchemeAndBuildingInlineSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="50"
    viewBox="0 0 60 50"
    fill="none"
  >
    <g clipPath="url(#clip0_771_16186)">
      <path
        d="M45.9448 39.6614V44.2291"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M57.2081 31.4839H34.6702C33.8519 31.4839 33.1885 32.1473 33.1885 32.9656V38.1795C33.1885 38.9979 33.8519 39.6612 34.6702 39.6612H57.2081C58.0264 39.6612 58.6898 38.9979 58.6898 38.1795V32.9656C58.6898 32.1473 58.0264 31.4839 57.2081 31.4839Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.9448 35.5728H53.0415"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M55.9602 35.5726C55.9602 35.4166 55.8265 35.283 55.6705 35.283C55.5146 35.283 55.3809 35.4166 55.3809 35.5726C55.3809 35.7286 55.5146 35.8623 55.6705 35.8623C55.8265 35.8623 55.9602 35.7286 55.9602 35.5726Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M57.2081 18.3823H34.6702C33.8519 18.3823 33.1885 19.0457 33.1885 19.8641V25.078C33.1885 25.8963 33.8519 26.5597 34.6702 26.5597H57.2081C58.0264 26.5597 58.6898 25.8963 58.6898 25.078V19.8641C58.6898 19.0457 58.0264 18.3823 57.2081 18.3823Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.9448 22.46H53.0415"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M55.9602 22.4598C55.9602 22.3039 55.8265 22.1702 55.6705 22.1702C55.5146 22.1702 55.3809 22.3039 55.3809 22.4598C55.3809 22.6158 55.5146 22.7495 55.6705 22.7495C55.8265 22.7495 55.9602 22.6158 55.9602 22.4598Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.6814 5.26953H57.2082C58.0326 5.26953 58.6899 5.93798 58.6899 6.75126V11.954C58.6899 12.7784 58.0215 13.4358 57.2082 13.4358H34.6814C33.857 13.4358 33.1997 12.7673 33.1997 11.954V6.75126C33.1997 5.92684 33.8682 5.26953 34.6814 5.26953Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.9448 9.3584H53.0415"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M55.9602 9.35826C55.9602 9.20229 55.8265 9.0686 55.6705 9.0686C55.5146 9.0686 55.3809 9.20229 55.3809 9.35826C55.3809 9.51424 55.5146 9.64793 55.6705 9.64793C55.8265 9.64793 55.9602 9.51424 55.9602 9.35826Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.3691 39.6614V44.2291"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.9448 31.484V26.5486"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.9448 18.3824V13.447"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.9536 44.229H10.7954V49.3872H15.9536V44.229Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.5181 44.229H43.3599V49.3872H48.5181V44.229Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M43.36 46.8025H15.9536"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.5181 46.8025H58.6896"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.7956 46.8025H0.624023"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.9365 39.6613H4.40086C3.66557 39.6613 3.06396 39.0597 3.06396 38.3244V16.1207C3.06396 15.5637 3.52074 15.1069 4.07778 15.1069H22.6607C23.2177 15.1069 23.6745 15.5637 23.6745 16.1207V37.9122C23.6745 38.8814 22.8946 39.6613 21.9254 39.6613H21.9365Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50635 15.1069V9.14659C6.50635 8.62297 6.9297 8.18848 7.46446 8.18848H19.2849C19.8085 8.18848 20.243 8.61183 20.243 9.14659V15.1069"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.69238 8.18843C9.69238 6.1608 11.3412 4.51196 13.3689 4.51196C15.3965 4.51196 17.0453 6.1608 17.0453 8.18843"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3691 4.51193V0.623779"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_771_16186">
        <rect width="59.3137" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default SchemeAndBuildingInlineSVG;
